import type { LocationQuery, Router } from 'vue-router'
import { normalizeToArray } from '@/utils/array.utils'
import { parsePositiveInt } from '@/utils/common.utils'

/** A scalar key may still arrive repeated; the last value wins, as a form resubmission would. */
export function lastQueryValue(value: LocationQuery[string] | undefined): string | null {
  return normalizeToArray(value).at(-1) ?? null
}

export function lastQueryId(value: LocationQuery[string] | undefined): number | null {
  const text = lastQueryValue(value)

  return text === null ? null : parsePositiveInt(text)
}

export function queryWithout(query: LocationQuery, keys: readonly string[]): LocationQuery {
  const next = { ...query }

  for (const key of keys)
    delete next[key]

  return next
}

export function parsePreviousQueryUrl(router: Router): Record<string, string> {
  const previousUrl = typeof router.options.history.state.back === 'string' ? router.options.history.state.back : ''
  if (!previousUrl)
    return {}

  const [, previousQueryString] = previousUrl.split('?')

  return Object.fromEntries(new URLSearchParams(previousQueryString))
}

type PaginatedQuery = { page?: number; pageSize?: number; offset?: number; limit?: number }

export function isQuerySameExceptPaging<T extends PaginatedQuery>(q1: T, q2: T): boolean {
  return isQuerySame(
    { ...q1, page: undefined, pageSize: undefined, offset: undefined, limit: undefined },
    { ...q2, page: undefined, pageSize: undefined, offset: undefined, limit: undefined },
  )
}

export function isQuerySame<T extends PaginatedQuery>(q1: T, q2: T): boolean {
  return JSON.stringify(q1) === JSON.stringify(q2)
}
